import type { JSX } from 'react';
import styles from './fixcenter-support-visit-us.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';
import { useTranslation } from '../../i18n/useTranslation';
import { VISIT_US_GOOGLE_STREET_URL } from '../../shared/constants/external-urls.constants';
import { useNavigate } from 'react-router-dom';
import { getLinkToVisitUs } from './fixcenter-support.service';

const FixcenterSupportVisitUsDropDown: React.FC = (): JSX.Element => {
    const htmlId: string = 'fixcenter-support-visit-us-drop-down';
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    const openGoogleStreetSite = () => {
        window.open(VISIT_US_GOOGLE_STREET_URL, '_blank');
    };

    const navigateToVisitUsFrom = () => {
        navigate(getLinkToVisitUs());
    };

    return (
        <>
            <div className={styles.drop_down_menu_container}>
                <span className={styles.arrow_down_on}></span>
                <div className={classNames(globalStyles.space_between_item, globalStyles.h_100, styles.wrapper)}>
                    <section className={globalStyles.w_50}>
                        <label className={styles.header_text}>{t('VISIT_US_DEF.IN_360')}</label>
                        <button
                            onClick={(): void => {
                                openGoogleStreetSite();
                            }}
                            id={`${htmlId}-google-street-btn`}
                            className={globalStyles.default_button_style}
                        >
                            <div
                                className={classNames(
                                    globalStyles.fixcenter_support_visit_us_sprites,
                                    globalStyles.img_1
                                )}
                            ></div>
                        </button>
                    </section>
                    <section className={globalStyles.w_50}>
                        <label className={styles.header_text}>{t('VISIT_US_DEF.ASK_YOUR_VISIT')}</label>
                        <button
                            onClick={(): void => {
                                navigateToVisitUsFrom();
                            }}
                            className={globalStyles.default_button_style}
                            id={`${htmlId}-ask-your-visit-btn`}
                        >
                            <div
                                className={classNames(
                                    globalStyles.fixcenter_support_visit_us_sprites,
                                    globalStyles.img_2
                                )}
                            ></div>
                        </button>
                    </section>
                </div>
            </div>
        </>
    );
};

export default FixcenterSupportVisitUsDropDown;
